import * as React from "react";
import ReactPlayer from 'react-player'

import '@blueprintjs/core/lib/css/blueprint.css';
import { Intent, Classes } from "@blueprintjs/core";
import { Button,ButtonGroup, Card, Elevation, Overlay,H4 } from "@blueprintjs/core";






export default class CardViewerAudio extends React.Component  <{}> {
  state = {
    name: '',
    force_height:'240px',
    force_height2:'480px',
    force_width:'360px',
    parent_height:480,
    isOpenEdit:false,
    isOpenDelete:false,
    title_document_creation:'',
    description_document_creation:'',
    objectif_document_creation:'',
    typeflex:'initial',
    status_published:"eye-off",
    youtube_frame:'',
    showcontenu:'block',
    url_video:'',
    elargir:'arrow-right',
    url_video2:'',
    url_video_zoom:'zoom/?url=',
    crossdomain:false,
    loadthegraph:''
  }  
  conteneurRef=null;
  
  constructor(props) {
        super(props);
        this.conteneurRef = React.createRef()
       // this.handleChange = this.handleChange.bind(this);
      }
  componentDidMount () { 
  // console.log("componentDidMount dans CardDocument")
  //  console.log(this.props);
  var that=this;
   this.setState({title_document_creation:this.props.title_document});
   this.setState({description_document_creation:this.props.description});
   this.setState({objectif_document_creation:this.props.objectif})
   this.setState({youtube_frame:this.props.youtube_frame});
   this.setState({url_video:this.props.url_video});
   var host=window.location.toString();
   var ll=host;
   if(ll.split('https:').length>1)host="";
   if(ll.split('http:').length>1)host="";
   //this.setState({url_video_zoom:'zoom/?url='+host+this.props.url_video});
   this.setState({url_video_zoom:host+this.props.url_video});
   this.setState({url_video2:this.props.url_video});
   this.setState({force_height:'80px'}); 
   this.setState({loadthegraph:'needloaded'})
   this.setState({parent_height:280})
   this.setState({typeflex:'100%'})
    

  }
  
  componentDidUpdate(prevProps, prevState) {
    
    if(this.state.loadthegraph=='needloaded')
    {
        if(this.state.url_video_zoom!="")if(window.load_graph!=undefined)
        {
          var ret=window.load_graph(this.state.url_video_zoom,this.props.id_document,64);
          if(ret==1) this.setState({loadthegraph:'loaded'})
        }
    }
    if(prevProps.youtube_frame!=this.state.youtube_frame) this.setState({youtube_frame:prevProps.youtube_frame});
    if(prevProps.youtube_frame=='true') 
    {
      if(prevProps.url_video!=this.state.url_video) this.setState({url_video:prevProps.url_video});
    }
    else{
      if(prevProps.url_video!=this.state.url_video2) this.setState({url_video2:prevProps.url_video});
    }
    
  }
  
   render() {
    
    const {type_audio,title_document,description,objectif,isnotdocument,navFiles,state,isnotconnected,menuVisibility,isOpenSign,usernickname,isOpenLogin,handleOpenVisio,handleOpen,handleClose,handleChange,handleSendCnx,handleSelectionChange,handleSelectionGetLogin,handleOpenLogin,handleCloseLogin,handleChangeLogin,handleSendCnxLogin}=this.props;
    
   
    

    return(
     <div style={{display:isnotdocument,width:'100%',minWidth: 360,margin:4,flex:this.state.typeflex,zIndex:1}}>
     
     
     <Card style={{width:'100%',margin:2,padding: '10px 0 0 5px',objectFit:'contain'}} interactive={true} elevation={Elevation.TWO}>    
     <div ref={(ref) => this.conteneurRef = ref} style={{display:this.state.showcontenu}}>
     <div style={{height:'64px'}} id={"waveform" +this.props.id_document}></div><div id={"timeline"+this.props.id_document}></div>
     <ButtonGroup style={{padding:4}} minimal={true} ><Button onClick={()=>{this.props.handleSetordreRecorder('play');}} intent={Intent.PRIMARY} icon='play' id={'idbtnplay'+this.props.id_document} data-action="play"></Button><Button onClick={()=>{this.props.handleSetordreRecorder('pause');}} style={{marginLeft:2}}intent={Intent.SUCCESS} icon='pause' id={'idbtnpause'+this.props.id_document} disabled={this.props.compteur==-1} data-action="pause"></Button> <Button onClick={()=>{this.props.handleSetordreRecorder('stop');}} style={{marginLeft:2}} intent={Intent.WARNING} icon='stop' id={'idbtnstop'+this.props.id_document} data-action="stop"></Button><Button style={{marginLeft:10}}icon="zoom-in"  id={'idbtnzoomin'+this.props.id_document}data-action="zoomin"></Button><Button style={{marginLeft:2}} icon="zoom-out"  id={'idbtnzoomout'+this.props.id_document}data-action="zoomout"></Button></ButtonGroup>
     </div>
     </Card>
     
     
     
     </div>);
}
}
